import React, { useEffect, useState } from 'react'
import { Card, Input } from 'antd';
import './style.css'
import { FaSquarePlus } from "react-icons/fa6";
import { IoClose } from 'react-icons/io5';


const OptionsGenerator = (props) => {
    const {onChange, limit} = props

    const [options, setOptions] = useState([
        { id: 1, value: '' },
        { id: 2, value: '' }
    ])
    const [selectedOption, setSelectedOption] = useState('')
    const [editData, setEditData] = useState(props?.onEdit())

    const handleOptions = (e, optionId) => {
        setSelectedOption(optionId)
        const selected = options.filter(e => e.id === optionId)[0]
        const rem = options.filter(e => e.id !== optionId)
        if (selected) {
            selected.value = e.target.value
            setOptions([])
            setOptions([...rem, selected].sort((a, b) => a.id - b.id))
        }
    }

    const incrementOption = () => {
        if (options.length <= limit) {
            setOptions([...options, { id: options[options.length-1].id+1, value: '' }])
        }
        // else alert('Max limit allowed is 5')
    }

    const handleRemoveOption = (optionId) => {
        setOptions(options.filter(e=>e.id != optionId).sort((a, b) => a.id - b.id))
    }

    useEffect(() => {
      onChange(options)
    }, [options])
    
    useEffect(() => {
        if(editData){
          setOptions([])
          setOptions(editData.map(item => ({ id: item.id, value: item.option }) ))
        }
    }, [editData])
    

    return (
        <>
            {options.length && options.map((option, index) => (
                <Card bordered={false} className='options-body mb-2'>
                    <Input
                        placeholder={`option ${option.id}`}
                        name={`option ${option.id}`}
                        value={option.value}
                        onChange={(e) => handleOptions(e, option.id)}
                        className='border-0'
                        maxLength={30}
                        suffix={
                            <React.Fragment>
                                { options.length > 2 && (index != 0 && index != 1) && (
                                <span className={`${!option.value && 'pointer-events-none'}`}>
                                    <IoClose
                                        className={`
                                            text-md 
                                            cursor-pointer
                                            ${!option.value ? 'text-slate-300' : 'text-slate-600'}
                                        `}
                                        onClick={()=>handleRemoveOption(option.id)}
                                    />
                                </span>
                                ) }
                            </React.Fragment>
                        }
                    />
                </Card>
            ))}
            <div className={`flex justify-end w-full ${options.length >= 10 && 'pointer-events-none'}`}>
                <div className='flex items-center cursor-pointer' onClick={incrementOption}>
                    <FaSquarePlus className='text-2xl rounded text-primary' />
                    <small className='ml-2 font-medium' >Add More</small>
                </div>
            </div>
        </>
    )
}

export default OptionsGenerator